import request from '@/apis/request'
const resource = 'cashback' 
const resource2 = 'cashback-tiers' 

export default {
  get: (params = {}) => {
    return request.get(`${resource}`, { params })
  }, 

  getTier: (params = {}) => {
    return request.get(`${resource2}`, { params })
  },
}